/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {ThirdPartyAudienceResource} from '../../components/api/resources/resource/third-party-audience.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-third-party-audience-route-page',
  template: `
    <adn-third-party-audience-list-page
      *ngIf="list"
      [list]="list">
    </adn-third-party-audience-list-page>
  `
})
export class ThirdPartyAudienceRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ThirdPartyAudienceResource) private readonly ThirdPartyAudience: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork('MANAGE_SYSTEM')
      && !this.LocalUserPermissions.hasAny('MANAGE_AUDIENCES');
    this.adnListHelper.setUpList(this.list, this.ThirdPartyAudience, readOnly, 'fullThirdPartyAudienceList', {
      baseTable: 'thirdPartyAudience'
    });
  }
}
